import { createContext, useContext, useState } from 'react'

const ProviderContext = createContext()

export const ProviderContextProvider = ({ children }) => {
  const [providerInfo, setProviderInfo] = useState({
    id: null,
    displayName: '',
    kitRequestsEnabled: localStorage.getItem('provider_portal_kit_requests') === 'true',
  })

  return <ProviderContext.Provider value={{ providerInfo, setProviderInfo }}>{children}</ProviderContext.Provider>
}

export const useProviderContext = () => {
  const context = useContext(ProviderContext)
  if (!context) {
    throw new Error('useProviderContext must be used within a ProviderContextProvider')
  }
  return context
}
